import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';

import defaultStyles, { SelectionItemScss } from './selection-item.scss';

export interface Props {
    styles: SelectionItemScss;
    selected: boolean;
    children: React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

class SelectionItem extends React.PureComponent<Props> {
    render() {
        const { styles, onClick, selected } = this.props;
        return (
            <button
                type='button'
                onClick={onClick}
                className={classnames(styles.chip, { [styles.selected]: selected })}
            >
                {this.props.children}
            </button>
        );
    }
}

export default Styled(defaultStyles)(SelectionItem);
